import React, { useEffect, useState } from "react";
import thongBaoImage from '../assets/img/thongBaoTamNgung.jpg';
const PromoPopup = () => {
   const [showPopup, setShowPopup] = useState(true);

   //  useEffect(() => {
   //    setShowPopup(true); // Hiển thị popup khi trang tải
   //  }, []);
   // useEffect(() => {
   //    // Hiển thị popup khi trang tải và tự động đóng sau 10 giây
   //    const timer = setTimeout(() => {
   //       setShowPopup(false);
   //    }, 5000);

   //    // Xoá timer nếu component bị unmount
   //    return () => clearTimeout(timer);
   // }, []);

   const handleClose = () => {
      setShowPopup(false);
   };

   if (!showPopup) return null;

   return (
      <div style={styles.overlay}>
         <div style={styles.popup}>
            <button onClick={handleClose} style={styles.closeBtn}>
               X
            </button>
            {/* <a href="https://price.tvsi.com.vn/" >
               <img src="https://img.tvsi.com.vn/img-prs/TVSI_PRS_POPUP.jpg" alt="Chương trình khuyến mãi" style={styles.image} />
            </a> */}
            <a href="https://www.tvsi.com.vn/help-open-account.html" >
               <img src={thongBaoImage} style={styles.image} />
            </a>
         </div>
      </div>
   );
};
const styles = {
   overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
   },
   popup: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "0",
      borderRadius: "10px",
      overflow: "hidden",
      maxWidth: "725px",
      width: "90%",
   },
   closeBtn: {
      position: "absolute",
      top: "10px",
      right: "10px",
      zIndex: 10,
      background: "transparent",
      border: "none",
      fontSize: "18px",
      cursor: "pointer",
      color: "rgba(0,0,0,0.5)",
   },
   image: {
      width: "100%",
      height: "auto",
      display: "block",
   },
};
export default PromoPopup;
